if (!customElements.get('somi-scenes')) {
  customElements.define('somi-scenes', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = Array.from(this.querySelectorAll('[data-scene-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-scene-panel]'));
      if (!this.tabs.length) return;
      this.querySelector('.somi-scenes__tabs').setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', tab.dataset.panel);
        tab.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.activate(index);
        }, options);
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else if (event.key !== ' ') return;
          event.preventDefault();
          this.activate(next);
          this.tabs[next].focus();
        }, options);
      });
      this.panels.forEach(panel => {
        const tab = this.tabs.find(item => item.dataset.panel === panel.id);
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.tabIndex = 0;
      });
      document.addEventListener('shopify:block:select', event => {
        const tab = this.tabs.find(item => item === event.target || item.contains(event.target));
        if (tab) this.activate(this.tabs.indexOf(tab));
      }, options);
      this.activate(0);
    }
    activate(index) {
      const selected = this.tabs[index];
      this.tabs.forEach(tab => {
        const active = tab === selected;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => { panel.hidden = panel.id !== selected.dataset.panel; });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
